import React from "react";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";

import moment from "moment";

// estilos
import "./pptosNew.css";
import { Tooltip } from "@mui/material";

export const FacturasListaItem = ({ item }) => {
  console.log(item);

  return (
    <tr className="p-tr-body-global" key={item.id}>
      <td className="text-start">
        <Link className="LinkTable" to={`/facturas/${item.id}`}>
          <Tooltip title={item?.nombre_tipo_documento}>
            <span className="p-box-tipo-doc">
              {item?.nombre_tipo_documento?.substring(0, 1) || "F"}
            </span>
          </Tooltip>
          <span className="ms-3">{item.numero || "S/N"}</span>
        </Link>
      </td>
      <td className="text-center">
        <Link className="LinkTable" to={`/facturas/${item.id}`}>
          {moment(item.fecha_emision, "YYYY-MM-DD").format("DD-MM-YYYY")}
        </Link>
      </td>
      <td className="text-center">
        <Link className="LinkTable" to={`/facturas/${item.id}`}>
          {moment(item.fecha_vencimiento) < moment(new Date()) &&
          item.estado === "emitida" ? (
            <span style={{ color: "red" }}>
              {item.fecha_vencimiento
                ? moment(item.fecha_vencimiento, "YYYY-MM-DD").format(
                    "DD-MM-YYYY",
                  )
                : "--"}
            </span>
          ) : (
            <span>
              {item.fecha_vencimiento
                ? moment(item.fecha_vencimiento, "YYYY-MM-DD").format(
                    "DD-MM-YYYY",
                  )
                : "--"}
            </span>
          )}
        </Link>
      </td>
      <td className="text-center">
        <Link className="LinkTable" to={`/facturas/${item.id}`}>
          <div className="d-flex justify-content-center">
            {item.estado === "por emitir" && (
              <span className="p-pptos-estado p-por-aprobar">Por emitir</span>
            )}
            {item.estado === "pagada" && (
              <span className="p-pptos-estado p-pagada">Pagada</span>
            )}
            {item.estado === "emitida" && (
              <span className="p-pptos-estado p-emitida">Emitida</span>
            )}
            {item.estado === "anulada" && (
              <span className="p-pptos-estado p-anulada">Anulada</span>
            )}
          </div>
        </Link>
      </td>
      <td className="text-start">
        <Link className="LinkTable" to={`/facturas/${item.id}`}>
          {item.razon_social || "---"}
        </Link>
      </td>
      <td className="max-w-80">
        <Link className="LinkTable" to={`/facturas/${item.id}`}>
          {item.referencia}
        </Link>
      </td>
      <td className="text-end">
        <Link className="LinkTable" to={`/facturas/${item.id}`}>
          <NumberFormat
            value={item.monto_base ? parseFloat(item.monto_base) : 0}
            displayType={"text"}
            thousandSeparator={item.separacion_miles}
            decimalSeparator={item.separacion_decimales}
            prefix={`${item.simbolo} `}
            decimalScale={2}
            fixedDecimalScale={2}
          />
        </Link>
      </td>
      <td className="text-end">
        <Link className="LinkTable" to={`/facturas/${item.id}`}>
          <NumberFormat
            value={item.total_impuesto ? parseFloat(item.total_impuesto) : 0}
            displayType={"text"}
            thousandSeparator={item.separacion_miles}
            decimalSeparator={item.separacion_decimales}
            prefix={`${item.simbolo} `}
            decimalScale={2}
            fixedDecimalScale={2}
          />
        </Link>
      </td>
      <td className="text-end">
        <Link className="LinkTable" to={`/facturas/${item.id}`}>
          <NumberFormat
            value={item.total_factura ? parseFloat(item.total_factura) : 0}
            displayType={"text"}
            thousandSeparator={item.separacion_miles}
            decimalSeparator={item.separacion_decimales}
            prefix={`${item.simbolo} `}
            decimalScale={2}
            fixedDecimalScale={2}
          />
        </Link>
      </td>
      <td className="text-end">
        <Link className="LinkTable" to={`/facturas/${item.id}`}>
          <NumberFormat
            value={item.total_cobrado ? parseFloat(item.total_cobrado) : 0}
            displayType={"text"}
            thousandSeparator={item.separacion_miles}
            decimalSeparator={item.separacion_decimales}
            prefix={`${item.simbolo} `}
            decimalScale={2}
            fixedDecimalScale={2}
          />
        </Link>
      </td>
      <td className="text-end">
        <Link
          className="LinkTable"
          to={`/facturas/${item.id}`}
          style={{ position: "relative" }}
        >
          <NumberFormat
            value={
              item.total_por_cobrar ? parseFloat(item.total_por_cobrar) : 0
            }
            displayType={"text"}
            thousandSeparator={item.separacion_miles}
            decimalSeparator={item.separacion_decimales}
            prefix={`${item.simbolo} `}
            decimalScale={2}
            fixedDecimalScale={2}
          />
          {item.aplica_detraccion &&
          parseFloat(item.total_por_cobrar) ===
            parseFloat(item.total_detraccion) ? (
            <span
              style={{
                position: "absolute",
                marginBottom: 0,
                fontSize: "9px",
                top: "18px",
                right: "0px",
                color: "#8E24AA",
                backgroundColor: "#FCF1FF",
                padding: "0px 2px",
                borderRadius: "3px",
                width: "85px",
              }}
            >
              detracción {parseFloat(item.porcentaje_detraccion)}%
            </span>
          ) : (
            ""
          )}
        </Link>
      </td>
    </tr>
  );
};
